export default __webpack_public_path__ + "static/caramel-banner-79067fee9a5fe222291592a22af69010.webp";